import Reveal from "@/components/Reveal";
import { WHY_HIRE } from "@/lib/site";

export default function WhyHire({
  eyebrow = "Why Mahaney Law",
  title = "Why Hire Joseph M. Mahaney?",
}) {
  return (
    <div data-testid="why-hire-section">
      <Reveal>
        <div className="eyebrow text-gold">{eyebrow}</div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.05] tracking-tight mt-4 text-navy-900">
          {title}
        </h2>
        <div className="divider-gold mt-8" />
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {WHY_HIRE.map((c, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <div
              data-testid={`why-hire-card-${i}`}
              className="rounded-sm p-7 h-full border border-navy-900/10 bg-white hover:border-gold/60 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(10,25,47,0.25)] transition-all duration-300"
            >
              <div className="h-12 w-12 rounded-sm bg-gold/10 grid place-items-center">
                <c.icon className="h-5 w-5 text-gold" />
              </div>
              <h3 className="font-display text-xl mt-6 leading-tight text-navy-900">
                {c.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-navy-900/60">
                {c.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
